/* The above code is a JavaScript code that sets up the routing for a React application using React
Router. It imports various components and sets up routes for each component. The routing is then
rendered using ReactDOM. The code also includes the necessary imports for Bootstrap, jQuery, and
Popper.js. Finally, it includes code for service worker registration, which is used for offline
functionality in Progressive Web Apps. */

import React from "react";
import ReactDOM from "react-dom";
import { Route, BrowserRouter as Router,
  Switch, Redirect, withRouter
} from "react-router-dom";

import { Provider } from "react-redux";
import { store } from "./store";

// import { ToastContainer } from "react-toastify";
import Aboutus from "./Aboutus";
import App from "./App";
import Audiogallery from "./Audiogallery";
import Booknow from "./Booknow";
import Branches from "./Branches";
import Centersinmaharashtra from "./Centersinmaharashtra";
import Centersoutsideindia from "./Centersoutsideindia";
import Centersoutsidemaharashtra from "./Centersoutsidemaharashtra";
import Changepassword from "./Changepassword";
import Checkout from "./Checkout";
import Contactus from "./Contactus";
import Deeds from "./Deeds";
import Donationcontribution from "./Donationcontribution";
import Donationcontributionlist from "./Donationcontributionlist";
import Download from "./Download";
import Eshopping from "./Eshopping";
import Event_calendar from "./Event_calendar";
import Event_calendar_grid from "./Event_calendar_grid";
import Event_details from "./Event_details";
import Events from "./Events";
import EventsCalendarPage from "./EventsCalendarPage";
import Faq from "./Faq";
import Feedback from "./Feedback";
import Forgotpassword from "./Forgotpassword";
import Interactions from "./Interactions";
import Logout from "./Logout";
import Machine_test from "./Machine_test";
import MachineTestListingPage from "./MachineTestListingPage";
import Magazine from "./Magazine";
import Magazine_details from "./Magazine_details";
import Mycart from "./Mycart";
import News_details from "./News_details";
import Orderdetails from "./Orderdetails";
import Orders from "./Orders";
import Organizeatrip from "./Organizeatrip";
import Participants from "./Participants";
import Photogallery from "./Photogallery";
import Product_type from "./Product_type";
import Products from "./Products";
import Users from "./Products_details";
import Profile from "./Profile";
import Research from "./Research";
import Research_details from "./Research_details";
import Researchmain from "./Researchmain";
import Resetpassword from "./Resetpassword";
import SetPassword from "./SetPassword";
import Signin from "./Signin";
import Signup from "./Signup";
import Sitemap from "./Sitemap";
import Sitesearch from "./Sitesearch";
import Subscription from "./Subscription";
import Topics from "./Topics";
import Verifyotp from "./Verifyotp";
import Videogallery from "./Videogallery";
import Wallpapergallery from "./Wallpapergallery";
import AddressPage from "./address";
import EventDetails from "./eventDetails";
import EventDetailsPage from "./EventDetailsPage";
import EventListingPage from "./EventListingPage";
import NewHomePage from "./NewHomePage";
import * as serviceWorker from "./serviceWorker";

import "./index.css";
import "./assets/css/rfs.css";
import "./assets/css/style.css";
import "./assets/fontawesome/css/all.min.css";
import "react-toastify/dist/ReactToastify.css";

// import "./styles/bs-modal.css";
import "./assets/dist/js/bootstrap.bundle";
import FormValidator from "./FormValidation";
import PageNotFound from "./PageNotFound";


// ScrollToTop component for React Router v5
import { useLayoutEffect } from "react";
// Disable browser's automatic scroll restoration so React Router controls it fully
if (typeof window !== 'undefined' && 'scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}
function ScrollToTop({ children, location }) {
  useLayoutEffect(() => {
    // behavior:'instant' overrides css scroll-behavior:smooth directly, no CSS toggling needed
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [location.pathname]);
  return children;
}
const ScrollToTopWithRouter = withRouter(ScrollToTop);
const originalError = console.error;
const originalWarn = console.warn;

console.error = (...args) => {
  if (
    typeof args[0] === "string" &&
    (
      args[0].includes("validateDOMNesting") ||
      args[0].includes("Invalid DOM property")||
      args[0].includes("Failed to fetch")||
      args[0].includes("429") ||                     
      args[0].includes("Too Many Requests")||
      args[0].includes("Unexpected token <") ||
      args[0].includes("<!DOCTYPE")  
    )
  ) {
    return; // ignore these warnings
  }
  originalError(...args);
};

console.warn = (...args) => {
  if (
    typeof args[0] === "string" &&
    (
      args[0].includes("429") ||
      args[0].includes("Too Many Requests")
    )
  ) {
    return;
  }
  originalWarn(...args);
};

window.addEventListener("unhandledrejection", function (event) {
  const msg = event.reason?.message || "";

  if (
    msg.includes("Failed to fetch") ||
    msg.includes("429") ||
    msg.includes("Unexpected token <")   // 👈 ADD THIS
  ) {
    event.preventDefault();
  }
});

const routing = (
  <Provider store={store}>
    <Router>
      <ScrollToTopWithRouter>
        <div>
          <Switch>
          <Route exact path="/" component={NewHomePage} />
          {/* <Route exact path="/" component={App} /> */}
          <Route path="/products_details" component={Users} />
          <Route path="/event_details_legacy/:eventId?" component={Event_details} />
          <Route path="/event_details/:eventId?" component={EventDetailsPage} />
          <Route path="/signup" component={Signup} />
          <Route path="/verifyotp" component={Verifyotp} />
          <Route path="/profile" component={Profile} />
          <Route path="/contact-us" component={Contactus} />
          <Route path="/branches" component={Branches} />
          <Route
            path="/centers-in-maharashtra"
            component={Centersinmaharashtra}
          />
          <Route
            path="/centers-outside-of-maharashtra"
            component={Centersoutsidemaharashtra}
          />
          <Route
            path="/centers-outside-india"
            component={Centersoutsideindia}
          />
          <Route path="/feedback" component={Feedback} />
          <Route path="/site-map" component={Sitemap} />
          <Route path="/site-search" component={Sitesearch} />
          <Route path="/change-password" component={Changepassword} />
          <Route path="/forgot-password" component={Forgotpassword} />
          <Route
            path="/donation-contribution"
            component={Donationcontribution}
          />
          <Route path="/reset-password" component={Resetpassword} />
          <Route path="/set-password" component={SetPassword} />
          <Route path="/participants" component={Participants} />
          <Route
            path="/donation-contribution-list"
            component={Donationcontributionlist}
          />
          <Route path="/signin" component={Signin} />
          <Route path="/logout" component={Logout} />
          <Route path="/products" component={Products} />
          <Route path="/magazine" component={Magazine} />
          <Route path="/magazine_details" component={Magazine_details} />
          <Route path="/product_type" component={Product_type} />
          <Route path="/event-calendar" component={EventsCalendarPage} />
          <Route path="/event-calendar-grid" component={Event_calendar_grid} />
          <Route exact path="/events">
            <Redirect to="/booknow/Residential%20Study%20Courses/1" />
          </Route>
          <Route path="/events/:eventType/:eventTypeId" component={Events} />
          <Route path="/events/:eventType/:eventTypeId/:topicId" component={Events} />
          <Route path="/machine-test-legacy/:topicId/:languageId" component={Machine_test} />
          <Route exact path="/machine-test">
            <Redirect to="/booknow/Machine%20Tests/3" />
          </Route>
          <Route path="/machine-test/:categoryName/:categoryId/:topicId?" component={MachineTestListingPage} />
          <Route path="/mycart" component={Mycart} />
          <Route path="/eventDetails" component={EventDetails} />
          <Route path="/address" component={AddressPage} />
          <Route path="/checkout" component={Checkout} />
          <Route path="/magazine-subscription" component={Subscription} />
          <Route path="/order-history" component={Orders} />
          <Route path="/my-interactions" component={Interactions} />
          <Route path="/order-details/:orderId/:message?" component={Orderdetails} />
          <Route exact path="/booknow" component={EventListingPage} />
          <Route path="/booknow/:categoryName/:categoryId" component={EventListingPage} />
          <Route path="/topics" component={Topics} />
          <Route path="/news" component={Research} />
          <Route path="/download" component={Download} />
          <Route path="/photo-gallery" component={Photogallery} />
          <Route path="/video-gallery" component={Videogallery} />
          <Route path="/wallpaper-gallery" component={Wallpapergallery} />
          <Route path="/audio-gallery" component={Audiogallery} />
          <Route path="/research" component={Researchmain} />
          <Route path="/news-details" component={News_details} />
          <Route path="/about-us" component={Aboutus} />
          <Route path="/cycle-of-good-deeds" component={Deeds} />
          <Route path="/faqs" component={Faq} />
          <Route path="/e-shopping-help" component={Eshopping} />
          <Route path="/organize-a-trip" component={Organizeatrip} />
          <Route path="/research-details" component={Research_details} />
          <Route path="/form-validator" component={FormValidator} />
          <Route path="/newpage" component={NewHomePage} />
          <Route component={PageNotFound} />
          </Switch>
        </div>
      </ScrollToTopWithRouter>
    </Router>
  </Provider>
);

ReactDOM.render(routing, document.getElementById("root"));
//ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
